import React from "react";
import Card from "../../components/common/Card";
import Alert from "../../components/common/Alert";
import PageHeader from "../../components/common/PageHeader";
import Table from "../../components/common/Table";
import { useGetPermissionsQuery } from "../../store/api";

const PermissionList = () => {
  const { data, isLoading, isError, error } = useGetPermissionsQuery();

  const permissions = Array.isArray(data) ? data : [];

  const columns = [
    { key: "name", label: "Permission" },
    { key: "description", label: "Description" },
    { key: "category", label: "Category" },
  ];

  const rows = permissions.map((permission) => {
    const id = permission.permissionId || permission.id;
    const name = permission.name || permission.permissionName || "";
    const category = name.split(".")[0] || "GENERAL";

    return {
      id,
      name: <code className="text-sm text-slate-700">{name}</code>,
      description: permission.description || "-",
      category,
    };
  });

  return (
    <div className="space-y-6">
      <PageHeader
        title="Permissions"
        subtitle="View all available system permissions."
      />

      <Alert tone="info">
        <strong>Note:</strong> Permissions are managed by system administrators.
        Use the Roles page to assign permissions to roles.
      </Alert>

      <Card className="p-0">
        <div className="border-b border-slate-100 px-6 py-4 text-sm font-semibold text-slate-700">
          All Permissions
        </div>
        <div className="px-6 py-4">
          {isLoading && (
            <p className="text-sm text-slate-500">Loading permissions...</p>
          )}
          {isError && (
            <Alert tone="error">
              {error?.data?.detail || "Failed to load permissions."}
            </Alert>
          )}
          {!isLoading && !isError && (
            <Table
              columns={columns}
              rows={rows}
              emptyText="No permissions found."
            />
          )}
        </div>
      </Card>
    </div>
  );
};

export default PermissionList;
